import { useEffect, useState } from "react";

interface CdnSvgProps {
  url: string;
  className?: string;
}

const CdnSvg: React.FC<CdnSvgProps> = ({ url, className }) => {
  const [svgContent, setSvgContent] = useState("");
  useEffect(() => {
    fetch(url)
      .then((res) => res.text())
      .then((svg) => setSvgContent(svg))
      .catch(console.error);
  }, [url]);

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default CdnSvg;
